import { Injectable } from '@angular/core';

import { CityInterface, IdInterface } from '../data';
import { MemoryMapCacheRepository } from './memory-map-cache.repository';

@Injectable()
export class CityCacheRepository extends MemoryMapCacheRepository<CityInterface[]> {
    getKey(countryId: IdInterface): string {
        return 'CityCacheRepository' + String(countryId);
    }
}
